import CallToActionComponent from "@/components/Button";
import { forwardRef } from "react";
import styled from "styled-components";

// Cast to fix React 17 + @types/react 18 compatibility issue
const CallToAction = CallToActionComponent as any;

export const Wrapper = styled.div`
  position: relative;
  margin: 2.5rem 0;

  .swiper {
    margin-left: calc(var(--page-margin) - 1.5rem);
    margin-right: calc(var(--page-margin) - 1.5rem);

    padding-left: 1.5rem;
    padding-right: 1.5rem;

    ${({ theme }) => theme.mediaQueries.desktop} {
      // ensure product card shadow isn't cut off
      padding: 1.5rem;
      margin-left: -1.5rem;
      margin-right: -1.5rem;
    }

    @media screen and (min-width: 105rem) {
      max-width: 100rem;
    }
  }

  .swiper-pagination {
    margin-top: 1.5rem;
    position: relative;

    .swiper-pagination-bullet {
      margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 2px) !important;
      width: 1rem;
      height: 2px;
      background-color: ${({ theme }) => theme.colors.middleGrey};
      opacity: 100;
      border-radius: 999999px;
      pointer-events: none;

      &.swiper-pagination-bullet-active {
        background-color: ${({ theme }) => theme.colors.red};
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    background-color: ${({ theme }) => theme.colors.red};
    border-radius: 100%;
    width: 2.5rem;
    height: 2.5rem;
  }

  .swiper-button-next {
    right: 0;
  }

  .swiper-button-prev {
    left: 0;
  }
`;

const _Button = forwardRef<HTMLAnchorElement, any>((props, ref) => {
  const CallToActionTyped = CallToAction as any;
  return (
    <CallToActionTyped
      as="button"
      ref={ref}
      variant="primaryUnboxed"
      {...props}
    />
  );
});

_Button.displayName = "Button";

export const Button = styled(_Button as any)`
  background-color: ${({ theme }) => theme.colors.red};
  width: 2.5rem;
  height: 2.5rem;
  position: absolute;
  top: 45%;
  z-index: 1;
  border-radius: 100%;
  border: none;
  padding: 0;

  > div {
    width: 1.125rem;
    height: 2.5rem;
    margin: auto;

    path {
      stroke: ${({ theme }) => theme.colors.white};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.black};
    border: none;
  }
`;

export const ButtonPrev = styled(Button)`
  left: 1.5rem;
  ${({ theme }) => theme.mediaQueries.desktop} {
    left: 1.5rem;
  }
`;

export const ButtonNext = styled(Button)`
  right: 1.5rem;
  ${({ theme }) => theme.mediaQueries.desktop} {
    right: 1.5rem;
  }
`;
